import { render, staticRenderFns } from "./MaterialAttributeModal.vue?vue&type=template&id=f37c6244&scoped=true"
import script from "./MaterialAttributeModal.vue?vue&type=script&lang=js"
export * from "./MaterialAttributeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37c6244",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f37c6244')) {
      api.createRecord('f37c6244', component.options)
    } else {
      api.reload('f37c6244', component.options)
    }
    module.hot.accept("./MaterialAttributeModal.vue?vue&type=template&id=f37c6244&scoped=true", function () {
      api.rerender('f37c6244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/material/modules/MaterialAttributeModal.vue"
export default component.exports